import { Collapse } from "bootstrap";
import { FC, BaseFCProps } from "../components";

export const CollapseHeader: FC = ({ selector = '#header-navbar-btn'}: BaseFCProps = {}) => {
  const btn = document.querySelector(selector);
  if (!btn) return;
  btn.addEventListener('click', () => {
    const collapseElement = document.querySelector('#header-navbar');
    if (!collapseElement) return;
    new Collapse(collapseElement)
  })
}